import React from 'react';
import cn from 'classnames';
import { isMultiImageDeviation } from '../../DeviationViews/_helpers';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import s from './FullscreenDeviationPage.scss';
export const FullscreenPage = ({ deviation })=>{
    // multi-image version has a slightly updated layout unfortunately
    const isMultiImage = isMultiImageDeviation(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isMultiImage && s['multi-image'])
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        className: cn(isMultiImage && s['multi-image-actionbar']),
        deviation: deviation
    }));
};
export default FullscreenPage;

//# sourceMappingURL=FullscreenDeviationPage.js.map